import { assign, Machine } from "xstate";
import { CycleModule } from "@/store/modules/cycle.module";
import { toaster } from "@/utilities/toaster";
const cycleListingMachine = Machine({
    id: "CycleMachines",
    context: {
        searchData: {
            page: 1,
            pageSize: 10,
            sort: {
                field: "name",
                type: "none",
            },
            columnFilters: [],
            cycleFilters: {
                cycleName: "",
                employeeName: "",
                year: "",
                pmoTeamId: null,
                teamName: "",
                status: "",
            },
        },
        cycleId: "",
        ispageChanged: false,
    },
    initial: "idle",
    states: {
        idle: {
            on: {
                GETTING_CYCLES: { target: "gettingCycles", actions: "assignSearchData" },
            },
        },
        gettingCycles: {
            tags: "gettingCycles",
            invoke: {
                id: "gettingCycles",
                src: (context, event) => {
                    return CycleModule.GetCycles(context.searchData);
                },
                onDone: { target: "loadedCycles" },
                onError: { target: "serviceUnavailable" },
            },
        },
        loadedCycles: {
            on: {
                GETTING_CYCLES: { target: "gettingCycles", actions: "assignSearchData" },
                DELETE_CYCLES: { target: "deleteCycle", actions: "ispageChanged" },
                FETCH_REVIEWS_STATUS: { target: "fetchingReviewsStatus" },
            },
        },
        deleteCycle: {
            tags: "deleteCycle",
            on: {
                DELETING_CYCLES: { target: "deletingCycle" },
                CANCEL_DELETE: { target: "loadedCycles" },
            },
        },
        deletingCycle: {
            invoke: {
                id: "deletingCycle",
                src: (context, event) => {
                    return CycleModule.DeleteCycle(event.cycleId);
                },
                onDone: { target: "gettingCycles", actions: ["showToasterMessage", "setPage"] },
                onError: { target: "serviceUnavailable" },
            },
        },
        fetchingReviewsStatus: {
            invoke: {
                id: "fetchingReviewsStatus",
                src: (context, event) => {
                    return CycleModule.GettingCyceReviewsStatus(event.cycleId);
                },
                onDone: { target: "loadedReviewsStatus" },
                onError: { target: "loadedCycles" },
            },
        },
        loadedReviewsStatus: {
            on: {
                CLOSE_REVIEWS_STATUS: { target: "loadedCycles" },
            },
        },
        serviceUnavailable: {},
    },
}, {
    actions: {
        assignSearchData: assign({
            searchData: (context, event) => event.searchData,
        }),
        showToasterMessage: (context, event) => {
            toaster.ShowSuccess("Cycle deleted successfully");
        },
        setPage: assign({
            searchData: (context, event) => {
                if (context.ispageChanged) {
                    return {
                        ...context.searchData,
                        page: context.searchData.page - 1,
                    };
                }
                return context.searchData;
            },
        }),
        ispageChanged: assign({
            ispageChanged: (context, event) => event.ispageChanged,
        }),
    },
    services: {},
});
export default cycleListingMachine;
